// extracted by mini-css-extract-plugin
module.exports = {"resend_bloc":"ResendBloc_resend_bloc__gS_r7","resend":"ResendBloc_resend__bSim7","spinner":"ResendBloc_spinner__5Fr_Y"};